<div class="page">
  <div class="header">
    <button mat-icon-button type="button" (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>{{ esEdicion ? 'Editar municipio' : 'Agregar municipio' }}</h1>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="form" class="dialog-form">
      <mat-form-field appearance="outline">
        <mat-label>Nombre del municipio</mat-label>
        <input matInput formControlName="nombre" placeholder="Ej. Huajuapan de León" />
        @if (form.get('nombre')?.hasError('required')) {
          <mat-error>El nombre es obligatorio.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Acrónimo</mat-label>
        <input matInput formControlName="acronimo" maxlength="10" placeholder="Ej. HJP" />
        @if (form.get('acronimo')?.hasError('required')) {
          <mat-error>El acrónimo es obligatorio.</mat-error>
        }
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      class="add-boton"
      mat-flat-button
      type="button"
      [disabled]="guardando"
      (click)="guardar()"
    >
      {{ esEdicion ? 'Guardar cambios' : 'Agregar' }}
      <mat-icon>{{ esEdicion ? 'save' : 'add' }}</mat-icon>
    </button>
  </mat-dialog-actions>
</div>
